export const theme = {
  colors: {
    primary: 'rgb(43, 157, 212)',
    border: '#aaa',
  },
};

export type Theme = typeof theme;
